module.exports = __webpack_public_path__ + "static/hongmin_kim-ea82fdd96eb9b6c9d49cd41f15f5a88e.jpg";